module.exports = __webpack_public_path__ + "media/react/views/commissionProject/pharmalancers-full-logo-70a28aae512f5730027680ae3d0d44f8.png";